import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
import logger from "redux-logger";

import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { persistStore, persistReducer } from "redux-persist";
import { encryptTransform } from "redux-persist-transform-encrypt";
import AuthReducer, { AdminAuthReducer } from "./authReducer";
import { Reducer } from "react";

const appReducer = combineReducers({
  AuthReducer,
  AdminAuthReducer,
});

const transforms = [
  encryptTransform({
    secretKey: "ADHKHKDHKDKHKSHKHDSKHKSDKJ",
  }),
];

const persistConfig = {
  key: "root",
  storage,
  transforms,
  stateReconciler: autoMergeLevel2,
};
const persistedReducer = persistReducer(
  persistConfig,
  appReducer as Reducer<unknown, never>
);
const store = createStore(
  persistedReducer,

  applyMiddleware(thunk, logger)
);

export default store;
// Real bug found + fixed 2026-08-14, confirmed live on staging: this app
// never used <PersistGate>, the standard redux-persist safeguard that
// blocks rendering until rehydration from localStorage actually completes.
// Without it, persistStore()'s rehydration is a genuine RACE against
// whatever the app itself fetches and dispatches on mount (Settings.tsx's
// own fetchData() -> SUBSCRIPTIONDATA dispatch, for example) - if
// rehydration's REHYDRATE action lands AFTER a fresh fetch's dispatch,
// autoMergeLevel2 lets the OLD persisted accountRecord silently overwrite
// the just-fetched one, since accountRecord sits at exactly the depth
// autoMergeLevel2 treats as an opaque value to replace wholesale, not
// merge into. Confirmed live: a real credit purchase updated the DB
// correctly (verified directly via Mongo and via calling the exact same
// repository method the RPC uses), but the UI kept showing a stale
// balance from BEFORE the purchase indefinitely, surviving even a full
// hard page reload - exactly the signature of a persisted-storage replay
// winning a race against a fresh fetch, not a caching or reactivity bug
// in the usual sense. Exporting the persistor so index.tsx can wrap the
// app in <PersistGate>, which makes rehydration ALWAYS finish first by
// construction - eliminates the race entirely rather than just making it
// less likely to lose.
export const persistor = persistStore(store);
export type RootState = ReturnType<typeof appReducer>;
